// extracted by mini-css-extract-plugin
export default {"header":"timeline-audio-onboarding-module__header--vb8r4","container":"timeline-audio-onboarding-module__container--gebJy","thumb":"timeline-audio-onboarding-module__thumb--IPjrg"};